<template>
  <div class="module spec-tips" :id="moduleData.itemCode" style="padding-bottom: 30px;">
    <div class="module-label">提示信息</div>
    <div>
      1.检测报告中的样品重量以实验室称重为准，如送样量不满足标准要求，以实际收到样量参照GB/T 474等相应标准进行制备。<br>
      2.若不需要CMA标识，检测结果仅用于科研、教学、内部质量控制、产品研发等目的，不具有社会证明作用，仅供内部参考。<br>
      3.请将上述委托内容填写完整，如委托单位未指定或未填写上述分析标准等信息，视为认同实验室代选信息或无需相关服务。<br>
      4.分析备样的保存期为30天，分析备样保存到期后由我司有权自行处理样品（如有特殊留样要求请在备注栏注明）。<br>
      5.委托单位对检测结果如有异议，于检测报告完成之日起15日内向检测单位书面报出，同时附上《检测报告》原件及预付复验费，但不可重性试验的不进行复验。<br>
      6.实验室仅对收到的样品负责，检测结果仅反映该样品的评价，其结果使用及使用所产生的任何损失，实验室不承担任何责任。<br>
      7.若未告知不接受分包，则视为接受。SGS将分包到认可的检测机构。<br>
      8.本委托书受约束于本公司《通用服务条款》，详见附件或登录<a href="http://www.sgs.com/en/terms-and-conditions.aspx">http://www.sgs.com/en/terms-and-conditions.aspx</a>查询。
    </div>
  </div>
</template>

<script>
export default {
  name: "RemindInfo",
  props: {
    moduleData: {
      type: Object,
      default: null
    },
  }
}
</script>

<style scoped lang="scss">
#RemindInfo {
  color: rgb(51, 51, 51);
  font-size: 14px;
  line-height: 30px;
}
</style>